module.exports = __webpack_public_path__ + "static/media/dashboard_dark.2d765c7f.svg";